// initial state
const state = () => ({
  entries: null,
  selectedEntry: null,
  entryDefault: null
})

const getters = {
  getEntries(state) {
    return state.entries
  },
  getSelectedEntry(state) {
    return state.selectedEntry
  },
  getEntry(state, entryId) {
    const selectedEntry = state.entries.find(
      entry => entry.sys.id === entryId
    );
    return selectedEntry
  },
  getEntriesSorted: (state) => {
    return state.entries.sort((a, b) => a.fields.menuOrder - b.fields.menuOrder);
    // return sorted
  },
  getEntryDefault(state) {
    // return state.entries.find((a) => a.fields.menuOrder === 0);
    return state.entryDefault
  }
}

const mutations = {
  RESET_INITIAL_STATE(s) {
    const initial = state()
    Object.keys(initial).forEach(key => { s[key] = initial[key] })
  },
  SET_ENTRIES(state, payload) {
    state.entries = [...payload]
  },
  SET_ENTRY_DEFAULT(state, entry) {
    state.entryDefault = { ...entry}
  },
  SET_SELECTED_ENTRY(state, entry) {
    if (!entry)
      state.selectedEntry = null
    else
      state.selectedEntry = {...entry}
  }
}

const actions = {
  resetState: ({ commit }) => {
    commit('RESET_INITIAL_STATE');
  },
  setEntries: ({ commit, state }, entries) => {
    commit('SET_ENTRIES', entries)

    const defaultEntry = entries.find((a) => a.fields.menuOrder === 0);
    commit('SET_ENTRY_DEFAULT', defaultEntry)

  },
  setSelectedEntry({ commit, state }, entryId) {
    if (!entryId) {
      // clear the selectedEntry object
      commit('SET_SELECTED_ENTRY')
    } else {
      const selectedEntry = state.entries.find(
        entry => entry.sys.id === entryId
      );
      commit('SET_ENTRY_DEFAULT', selectedEntry)
    }
  }
}

export default {
  namespaced: true,
  state: state(),
  getters,
  actions,
  mutations
}
